import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const NAV_LINKS = [
  { label: 'Home', to: '/' },
  { label: 'Architecture', to: '/architecture' },
  { label: 'AI Chat', to: '/ai-chat' },
];

export default function Header() {
  const [mobileToggle, setMobileToggle] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setScrolled(scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setMobileToggle(false);
  }, [location]);

  const handleLetsTalk = () => {
    setMobileToggle(false);
    if (isHome) {
      // Already on home, scroll to contact
      const el = document.getElementById('contactus');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      // Navigate to home first, then scroll
      navigate('/#contactus');
    }
  };

  return (
    <div
      className={`header-top-fixed ${
        mobileToggle ? 'menu-open menu-open-desk' : ''
      } ${scrolled ? 'fixed-header' : ''}`}
    >
      <div className="container">
        <div className="logo">
          <Link className="navbar-brand" to="/" onClick={() => setMobileToggle(false)}>
            <span style={{
              fontSize: '24px',
              fontWeight: 700,
              color: '#ffffff',
              background: 'linear-gradient(135deg, #6c63ff, #00d4aa)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              letterSpacing: '-0.5px',
            }}>
              RS
            </span>
          </Link>
        </div>

        {/* Main Nav */}
        <ul className="main-menu">
          {NAV_LINKS.map((link) => (
            <li key={link.to}>
              <Link
                to={link.to}
                className={location.pathname === link.to ? 'active' : ''}
                onClick={() => setMobileToggle(false)}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>

        {/* CTA + Hamburger */}
        <div className="d-flex">
          <button
            onClick={handleLetsTalk}
            className="px-btn d-none d-lg-inline-flex"
            style={{ cursor: 'pointer' }}
          >
            Let's Talk
          </button>
          <button
            className="toggler-menu d-lg-none"
            onClick={() => setMobileToggle(!mobileToggle)}
          >
            <span />
          </button>
        </div>
      </div>
    </div>
  );
}
